<template>
  <div class="card card-last-session bg-transparent animate__animated animate__slideInLeft">
    <div class="card-body">
                <h3 class="mb-md-3"> {{$t('session.last.session')}}</h3>
      <div class="d-flex display-h6">
        <div class="pr-3 border-right">
          {{$t('session.card.duration')}}
          <span v-if="lastSession.duration > 0" class="font-weight-bold">
                          {{lastSession.duration}}</span>
          <span v-else>-</span>
           {{$t('session.card.duration.min')}}
        </div>
        <div class="pl-3 pr-3 border-right">
          {{$t('session.card.steps')}}
          <span class="font-weight-bold">
             {{lastSession.completed_activity}}/{{lastSession.activity_count}}
          </span>
        </div>
        <div class="pl-3 pr-3" v-if="lastSession.due_date">
          {{$t('session.card.expire.on')}}
          <span class="font-weight-bold">{{formatDate(lastSession.due_date)}}</span>
        </div>
      </div>
      <div class="card-title d-flex align-items-center my-4">
        <ProgressDonut :object="lastSession" :small="true" class="mr-3"/>
        <div class="title">
          <h1 class="font-weight-bold">{{lastSession.name}}</h1>
          <p class="card-text">{{lastSession.description}}</p>
          <div class="d-flex display-h6">
            <div v-if="false" class="d-flex align-items-center font-weight-light mr-2 cursor-hand"
                 @click="updateShowForum">
              <inline-svg
                class="mr-1"
                width="20" height="20"
                :src="require('../assets/images/icons/Icon_Topic.svg')"/>
              <span>
                 {{$t('app.label.forum')}} <span class="font-weight-bold mr-2">3</span>
              </span>
            </div>
            <div v-if="lastSession.badge_count > 0"
                 class="d-flex align-items-center font-weight-light">
              <inline-svg
                class="mr-1"
                width="20" height="20"
                :src="require('../assets/images/icons/Icon_Badges.svg')"/>
              <span>
                 {{$t('app.label.badges')}}
                <span class="font-weight-bold mr-2">
                  {{lastSession.activated_badge}}/{{lastSession.badge_count}}</span>
              </span>
            </div>
            <div v-if="lastSession.has_leaderboard == 1"
              class="d-flex align-items-center font-weight-light">
              <inline-svg
                class="mr-1"
                width="20" height="20"
                :src="require('../assets/images/icons/Icon_Leaderboard.svg')"/>
              <span>
                 {{$t('app.label.leaderboard')}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <template v-if="lastSession.due_date && isInferiorToToday(lastSession.due_date)">
        <span class="display-h5">{{$t('session.card.expired')}}</span>
      </template>
      <template v-else>
        <template v-if="isInferiorToToday(lastSession.start_date)">
          <a href="javascript:void(0)" @click="handleSessionClick(lastSession.id)"
             class="btn btn-primary font-weight-bold mt-3">
            {{$t('app.button.continue')}}
          </a>
        </template>
        <template v-else>
          <span class="display-h5">{{$t('session.card.available.on')}}
            <span class="font-weight-bold">{{ formatDate(lastSession.start_date) }}</span>
          </span>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HelperMixin from '@/mixins/helperMixin';

export default {
  name: 'LastSession',
  mixins: [HelperMixin],
  computed: {
    ...mapGetters(['lastSession']),
  },
};
</script>
